import type { Portal } from "./types";

/**
 * Derive the originating portal from a request or browser pathname. Used by
 * the API middleware outer catch (server) and the React error boundaries
 * (client) so captured errors carry the same multi-tenant tag regardless of
 * where they were thrown.
 *
 * Returns undefined for paths outside the four portals (e.g. /api/auth,
 * /api/cron, public marketing pages).
 */
export function derivePortalFromPath(pathname: string): Portal | undefined {
  if (pathname.startsWith("/superadmin") || pathname.startsWith("/api/admin"))
    return "superadmin";
  if (pathname.startsWith("/booking") || pathname.startsWith("/api/staff"))
    return "booking";
  if (pathname.startsWith("/barstaff")) return "barstaff";
  if (pathname.startsWith("/customerportal")) return "customerportal";
  return undefined;
}
